import { authAPI } from "../authApi"

export const authApiSlice = authAPI.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation<any, any>({
            query: ({ url, credentials }) => ({
                url: `${url}/security/account/login`,
                method: "POST",
                body: credentials,
                headers: {
                    'Content-Type': 'application/json',
                }
            })
        })
    })
})

export const {
    useLoginMutation
} = authApiSlice


